import { pushModal } from '../Modals/redux/basicActions';
import { ModalType } from '../Modals/redux/types';
export var pushVerificationPopup = function (actionType) {
    return pushModal(ModalType.VERIFICATION, {
        params: { actionType: actionType },
        wrapInModal: false,
    });
};
//# sourceMappingURL=actions.js.map